module.exports = __webpack_public_path__ + "static/media/works4.b1fc7301.png";